module.exports = __webpack_public_path__ + "officialStatic/img/fskLogo.1b194c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/fskLogo.png
// module id = Xgpn
// module chunks = 0